import React, { useMemo } from 'react'
import { useRouter } from 'next/router'

import { Button } from 'components/Common'
import TimeLocation from '../TimeLocation'

import { mergeStyles } from '@enlyt/base'

import defaultStyles from './styles'

const BookingConfirmation = ({ style, selectedTimeslot, locationSelected, onBookAppointment }) => {
  const styles = mergeStyles(defaultStyles, style)
  const routePathName = useRouter().pathname

  const isRescheduling = useMemo(() => {
    return routePathName.includes('visits')
  }, [routePathName])

  return (
    <div style={styles.section}>
      <div style={styles.dateTimeSelected}>Date &amp; Time Selected</div>
      <TimeLocation selectedTimeslot={selectedTimeslot} locationSelected={locationSelected} />
      <Button onClick={onBookAppointment}>
        {isRescheduling ? 'Reschedule Appointment' : 'Book Appointment'}
      </Button>
    </div>

  )
}

export default BookingConfirmation
